import React, { Suspense } from 'react'
import { RouteList } from 'config/routes'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import 'assets/styles/main.scss'
import 'i18n'
import { Provider } from 'jotai'
import { SocketContext, socket, setSocketRoomId } from 'utils/socket'
import { NotificationProvider } from 'contexts/NotificationContext'
import MusicPlayer from 'components/MusicPlayer/MusicPlayer'

export function App() {
	const routerList = RouteList()
	const router = createBrowserRouter([...routerList])
	return (
		<Provider>
			<Suspense fallback={<div></div>}>
				<SocketContext.Provider
					value={{
						socket: socket ?? { on: () => { }, off: () => { }, emit: () => { } },
						setSocketRoomId,
					}}
				>
					<NotificationProvider>
						<MusicPlayer />
						<RouterProvider router={router} />
					</NotificationProvider>
				</SocketContext.Provider>
			</Suspense>
		</Provider>
	)
}
